import React from 'react';
import { CondensedCard } from '../card/condensed-card.react-component';
import { HorizontalCard } from '../card/horizontal-card.react-component';
import { VerticalCard } from '../card/vertical-card.react-component';
import { TagList } from '../tag/tag-list.react-component';
/** React props for `CourseProductCard` */

/**
 * Returns a `TagList` node with `highlightedTag` prepended to the beginning of `tags`
 *
 * @internal
 */
const mergeTags = _ref => {
  let {
    tags,
    highlightedTag
  } = _ref;
  return (tags || highlightedTag) && /*#__PURE__*/React.createElement(TagList, {
    tags: [highlightedTag, ...(tags !== null && tags !== void 0 ? tags : [])].filter(tag => tag)
  });
};
/**
 * ### CourseProductCard component
 *
 * @remarks
 *
 * A card component for a Course. The card can be rendered in three different layouts:
 * `vertical`, `horizontal`, and `condensed`.
 */


export const CourseProductCard = _ref2 => {
  let {
    layout,
    ...props
  } = _ref2;

  switch (layout) {
    case 'condensed':
      return /*#__PURE__*/React.createElement(CourseCardCondensed, props);

    case 'horizontal':
      return /*#__PURE__*/React.createElement(CourseCardHorizontal, props);

    case 'vertical':
    default:
      return /*#__PURE__*/React.createElement(CourseCardVertical, props);
  }
};
/**
 * ### CourseCardVertical component
 *
 * @remarks
 *
 * A `VerticalCard` implementation for the Course card.
 *
 * @internal
 *
 * @see `VerticalCard` component
 */

const CourseCardVertical = _ref3 => {
  let {
    inlineSecondaryContent,
    mediaSquare,
    mediaWide,
    tags,
    ...props
  } = _ref3;
  const normalizedTags = tags && /*#__PURE__*/React.createElement(TagList, {
    tags: tags
  });
  return /*#__PURE__*/React.createElement(VerticalCard, Object.assign({
    media: mediaWide,
    tags: normalizedTags
  }, props));
};
/**
 * ### CourseCardCondensed component
 *
 * @remarks
 *
 * A `CondensedCard` implementation for the Course card.
 *
 * @internal
 *
 * @see `CondensedCard` component
 */


const CourseCardCondensed = _ref4 => {
  let {
    highlightedTag,
    mediaSquare,
    mediaWide,
    tags,
    ...props
  } = _ref4;
  const normalizedTags = mergeTags({
    tags,
    highlightedTag
  });
  return /*#__PURE__*/React.createElement(CondensedCard, Object.assign({
    media: mediaSquare,
    tags: normalizedTags
  }, props));
};
/**
 * ### CourseCardHorizontal component
 *
 * @remarks
 *
 * A `HorizontalCard` implementation for the Course card.
 *
 * @internal
 *
 * @see `HorizontalCard` component
 */


const CourseCardHorizontal = _ref5 => {
  let {
    highlightedTag,
    tags,
    ...props
  } = _ref5;
  const normalizedTags = mergeTags({
    tags,
    highlightedTag
  });
  return /*#__PURE__*/React.createElement(HorizontalCard, Object.assign({
    tags: normalizedTags
  }, props));
};
//# sourceMappingURL=course-product-card.react-component.js.map